import { keys } from "./Keys";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { useQuery } from "react-query";
import { IAlarmScheduleModel } from "../../services/alarm-schedule-data-service/Models";
import AlarmScheduleAdministrationDataService from "../../services/alarm-schedule-data-service/AlarmScheduleAdministrationService";


export type useAlarmScheduleParams = {
    organizationID: number,
    groupID: number,
    alarmScheduleID: number;
    includeLinkedAlarmSchemes: boolean,
} & BaseUseQueryParameters<IAlarmScheduleModel>;

export function useAlarmSchedule({
    organizationID,
    groupID,
    alarmScheduleID,
    includeLinkedAlarmSchemes,
    enabled,    
    onSuccess,
    onError
}: useAlarmScheduleParams) {
    return useQuery<IAlarmScheduleModel, RestError>(
        keys.alarmSchedule(organizationID, groupID, alarmScheduleID, includeLinkedAlarmSchemes),
        ({ signal }) => {
            return AlarmScheduleAdministrationDataService.getAlarmSchedule(
                organizationID,
                groupID,
                alarmScheduleID,
                includeLinkedAlarmSchemes,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            //refetchInterval: refreshSeconds ? refreshSeconds * 1000 : false,
            refetchInterval: false,
            //staleTime: 0,
            staleTime: Infinity,
            refetchOnWindowFocus: false,
            refetchOnMount: true,
            refetchOnReconnect: false,
            retry: false,
        }
    );
}